import { Column } from "react-table";

export default [
    {
        Header: 'Date',
        accessor: 'created_at',
        Cell: ({ value }) => (new Date(value)).toLocaleString('en-US', { timeZone: 'UTC', timeZoneName: 'short', year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }),
        minWidth: 180
    },
    {
        Header: 'Description',
        accessor: 'description',
        width: "100%"
    }
] as Column<Interfaces.Activity>[]